var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUtilizationThumbnail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 152,
    viewBox: "0 0 208 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C3.68629 1 1 3.68629 1 7V145C1 148.314 3.68629 151 7 151H201C204.314 151 207 148.314 207 145V7C207 3.68629 204.314 1 201 1H7Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4336 30.9805V126.819",
    stroke: "#CDCDCD",
    strokeWidth: 1.09819
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7383 30.9805V126.223",
    stroke: "#EEECEC",
    strokeWidth: 1.09819
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3691 30.9805V126.223",
    stroke: "#EEECEC",
    strokeWidth: 1.09819
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.942 30.9805V126.223",
    stroke: "#EEECEC",
    strokeWidth: 1.09819
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.573 30.9805V126.223",
    stroke: "#EEECEC",
    strokeWidth: 1.09819
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M184.203 30.9805V126.223",
    stroke: "#EEECEC",
    strokeWidth: 1.09819
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4326 126.539H187.379",
    stroke: "#CDCDCD",
    strokeWidth: 1.09819
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4336 106.656H187.378",
    stroke: "#EEECEC",
    strokeWidth: 1.09819
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4336 86.4922H187.378",
    stroke: "#EEECEC",
    strokeWidth: 1.09819
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4336 66.3281H187.378",
    stroke: "#EEECEC",
    strokeWidth: 1.09819
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4336 46.1641H187.378",
    stroke: "#EEECEC",
    strokeWidth: 1.09819
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4677 58.208L37.4346 55.6875V126.261H110.777H184.119V48.406L154.782 40.5645L124.142 53.167L95.9125 45.8855L65.4677 58.208Z",
    fill: "url(#paint0_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1074 55.6851L66.1829 57.9255L95.9119 46.4432L124.334 52.8845L154.782 40.002L183.793 48.9637",
    stroke: "#BFBFBF",
    strokeWidth: 2.19637
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6456 105.369C18.1845 105.369 17 106.554 17 108.015V108.015C17 109.476 18.1845 110.66 19.6456 110.66H27.0666C28.5278 110.66 29.7123 109.476 29.7123 108.015V108.015C29.7123 106.554 28.5278 105.369 27.0666 105.369H19.6456Z",
    fill: "#D1D3D4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6456 86.3203C18.1845 86.3203 17 87.5048 17 88.9659V88.9659C17 90.4271 18.1845 91.6116 19.6456 91.6116H27.0666C28.5278 91.6116 29.7123 90.4271 29.7123 88.9659V88.9659C29.7123 87.5048 28.5278 86.3203 27.0666 86.3203H19.6456Z",
    fill: "#D1D3D4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6456 67.2715C18.1845 67.2715 17 68.456 17 69.9171V69.9171C17 71.3783 18.1845 72.5627 19.6456 72.5627H27.0666C28.5278 72.5627 29.7123 71.3783 29.7123 69.9171V69.9171C29.7123 68.456 28.5278 67.2715 27.0666 67.2715H19.6456Z",
    fill: "#D1D3D4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6456 48.2227C18.1845 48.2227 17 49.4071 17 50.8683V50.8683C17 52.3294 18.1845 53.5139 19.6456 53.5139H27.0666C28.5278 53.5139 29.7123 52.3294 29.7123 50.8683V50.8683C29.7123 49.4071 28.5278 48.2227 27.0666 48.2227H19.6456Z",
    fill: "#D1D3D4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6456 121.242C18.1845 121.242 17 122.427 17 123.888V123.888C17 125.349 18.1845 126.533 19.6456 126.533H27.0666C28.5278 126.533 29.7123 125.349 29.7123 123.888V123.888C29.7123 122.427 28.5278 121.242 27.0666 121.242H19.6456Z",
    fill: "#D1D3D4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0333 129.707C61.5722 129.707 60.3877 130.892 60.3877 132.353V132.353C60.3877 133.814 61.5722 134.998 63.0333 134.998H70.4543C71.9155 134.998 73.1 133.814 73.1 132.353V132.353C73.1 130.892 71.9155 129.707 70.4543 129.707H63.0333Z",
    fill: "#D1D3D4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0206 129.707C33.5595 129.707 32.375 130.892 32.375 132.353V132.353C32.375 133.814 33.5595 134.998 35.0206 134.998H42.4416C43.9028 134.998 45.0873 133.814 45.0873 132.353V132.353C45.0873 130.892 43.9028 129.707 42.4416 129.707H35.0206Z",
    fill: "#D1D3D4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6652 129.707C91.204 129.707 90.0195 130.892 90.0195 132.353V132.353C90.0195 133.814 91.204 134.998 92.6652 134.998H100.086C101.547 134.998 102.732 133.814 102.732 132.353V132.353C102.732 130.892 101.547 129.707 100.086 129.707H92.6652Z",
    fill: "#D1D3D4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.296 129.707C120.835 129.707 119.65 130.892 119.65 132.353V132.353C119.65 133.814 120.835 134.998 122.296 134.998H129.717C131.178 134.998 132.363 133.814 132.363 132.353V132.353C132.363 130.892 131.178 129.707 129.717 129.707H122.296Z",
    fill: "#D1D3D4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.927 129.707C150.466 129.707 149.281 130.892 149.281 132.353V132.353C149.281 133.814 150.466 134.998 151.927 134.998H159.348C160.809 134.998 161.994 133.814 161.994 132.353V132.353C161.994 130.892 160.809 129.707 159.348 129.707H151.927Z",
    fill: "#D1D3D4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.559 129.707C180.098 129.707 178.913 130.892 178.913 132.353V132.353C178.913 133.814 180.098 134.998 181.559 134.998H188.98C190.441 134.998 191.625 133.814 191.625 132.353V132.353C191.625 130.892 190.441 129.707 188.98 129.707H181.559Z",
    fill: "#D1D3D4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 110.777,
    y1: 40.5645,
    x2: 110.777,
    y2: 126.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilizationThumbnail);
export default __webpack_public_path__ + "static/media/utilization-thumbnail.2d0c5da962513a241f1bdeffc1cb79c8.svg";
export { ForwardRef as ReactComponent };